/*!
 * PRWMade Fundraiser — theme asset (assets/prw-fundraiser.js)
 * - captures ?ref into a first-party cookie (prw_fund_ref); supports clearing it
 * - calls the Worker; swaps PDP images for the active fundraiser by IMAGE URL (theme-agnostic)
 * - powers /pages/active-fundraisers: picker (dropdown + code + "none"), browse grid, live view
 * - fills #prw-fundraiser-banner on the PDP only when a valid fundraiser is active
 * GOAFFPRO tracks commission attribution on its own; this only drives the storefront UX.
 */
(function () {
  "use strict";
  if (window.PRWFundraiser) return; // guard against double-load (global + section)

  // ---- CONFIG ----
  var WORKER_URL = "https://prwmade-proof.gilreathdrg.workers.dev/fundraiser";
  var LIST_URL = WORKER_URL + "s"; // .../fundraisers
  var CUSTOMER_PAGE = "/pages/active-fundraisers"; // supporter shopping page
  var COOKIE = "prw_fund_ref";
  var COOKIE_DAYS = 30;

  // ---------- ref cookie ----------
  function slug(s) {
    return String(s || "").toLowerCase().replace(/[^a-z0-9_-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80);
  }
  function getParam(name) { return new URLSearchParams(window.location.search).get(name); }
  function setCookie(v) {
    var d = new Date(); d.setTime(d.getTime() + COOKIE_DAYS * 864e5);
    document.cookie = COOKIE + "=" + encodeURIComponent(v) + ";expires=" + d.toUTCString() + ";path=/;SameSite=Lax";
  }
  function clearRef() { document.cookie = COOKIE + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax"; }
  function getCookie() {
    var m = document.cookie.match(new RegExp("(?:^|; )" + COOKIE + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function activeRef() {
    var q = slug(getParam("ref"));
    if (q) { setCookie(q); return q; }
    return getCookie();
  }

  // ---------- worker ----------
  function fetchFundraiser(ref) {
    return fetch(WORKER_URL + "?ref=" + encodeURIComponent(ref), { credentials: "omit" })
      .then(function (r) { return r.json(); }).catch(function () { return { valid: false, reason: "error" }; });
  }
  function fetchList() {
    return fetch(LIST_URL, { credentials: "omit" })
      .then(function (r) { return r.json(); }).then(function (d) { return (d && d.fundraisers) || []; })
      .catch(function () { return []; });
  }

  // ---------- PDP image swap (by image URL — works on any theme markup) ----------
  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function stemOf(url) {
    if (!url) return null;
    var base = String(url).split("?")[0].split("/").pop();
    return base.replace(/\.(jpe?g|png|webp|gif|avif)$/i, "").replace(/_\d+x\d*$/i, "");
  }
  function preDim(ref) {
    if (!ref || !currentHandle()) return;
    var st = document.createElement("style");
    st.id = "prw-predim";
    st.textContent = "html.prw-ref-pending .product__media img,html.prw-ref-pending [data-product-media] img,html.prw-ref-pending .product__media-item img{opacity:0;transition:opacity .18s ease}";
    document.head.appendChild(st);
    document.documentElement.classList.add("prw-ref-pending");
    setTimeout(reveal, 1400);
  }
  function reveal() { document.documentElement.classList.remove("prw-ref-pending"); }
  function swapPdpImage(payload) {
    reveal();
    var handle = currentHandle();
    if (!handle || !payload.products) return;
    var match = payload.products.filter(function (p) { return p.handle === handle && p.design_image; })[0];
    if (!match) return;
    var stem = stemOf(match.featured_image);
    var applied = 0;
    document.querySelectorAll("img").forEach(function (img) {
      var hay = (img.getAttribute("src") || "") + " " + (img.getAttribute("srcset") || "") + " " +
                (img.getAttribute("data-src") || "") + " " + (img.getAttribute("data-srcset") || "") + " " + (img.currentSrc || "");
      if (stem && hay.indexOf(stem) > -1) {
        img.setAttribute("src", match.design_image);
        ["srcset", "data-src", "data-srcset", "data-widths", "data-zoom", "data-original"].forEach(function (a) { img.removeAttribute(a); });
        if (match.design_alt) img.setAttribute("alt", match.design_alt);
        applied++;
      }
    });
    document.querySelectorAll("picture source").forEach(function (s) {
      var hay = (s.getAttribute("srcset") || "") + " " + (s.getAttribute("data-srcset") || "");
      if (stem && hay.indexOf(stem) > -1) { s.setAttribute("srcset", match.design_image); s.removeAttribute("data-srcset"); }
    });
    if (applied === 0) {
      var el = document.querySelector(".product__media img, [data-product-media] img, .product-gallery img, .product__media-item img");
      if (el) { el.setAttribute("src", match.design_image); el.removeAttribute("srcset"); if (match.design_alt) el.setAttribute("alt", match.design_alt); }
    }
  }

  // ---------- rendering ----------
  function money(n) {
    if (n == null) return null;
    return "$" + Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function daysLeft(end) {
    if (!end) return null;
    var d = Math.ceil((new Date(end).getTime() - Date.now()) / 864e5);
    return d >= 0 ? d : null;
  }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]; }); }
  function progressBar(p) {
    if (p.raised == null || !p.goal) return "";
    var pct = Math.max(0, Math.min(100, (p.raised / p.goal) * 100));
    return '<div class="prw-fund-progress"><div class="prw-fund-bar"><span style="width:' + pct.toFixed(1) + '%"></span></div>' +
      '<div class="prw-fund-stats"><strong>' + money(p.raised) + "</strong> raised of " + money(p.goal) +
      (p.orders != null ? " · " + p.orders + " order" + (p.orders === 1 ? "" : "s") : "") + "</div></div>";
  }
  // Greenspark giving-back — canonical per-order impact (constant, does not scale with order size/price).
  // Source: greenspark_giveback_copy_audit_2026-08-11 — every order plants 2 trees, recovers 6 ocean-bound
  // plastic bottles, protects 20 bees.
  var IMPACT_PER_ORDER = { trees: 2, bottles: 6, bees: 20 };
  function count(n) { return Number(n).toLocaleString("en-US"); }
  function ensureImpactStyles() {
    if (document.getElementById("prw-impact-css")) return;
    var st = document.createElement("style");
    st.id = "prw-impact-css";
    st.textContent =
      ".prw-impact{background:var(--prw-panel);border:1px solid var(--prw-line);border-radius:16px;padding:1.15rem 1.25rem;margin:1.25rem 0 .4rem}" +
      ".prw-impact-head{text-align:center;color:var(--prw-muted);font-size:.9rem;margin:0 0 .9rem}" +
      ".prw-impact-row{display:grid;grid-template-columns:repeat(3,1fr);gap:.85rem}" +
      "@media(max-width:640px){.prw-impact-row{grid-template-columns:1fr}}" +
      ".prw-impact-card{display:flex;align-items:center;gap:.7rem;background:#fff;border:1px solid var(--prw-line);border-radius:12px;padding:.85rem 1rem}" +
      ".prw-impact-icon{font-size:1.6rem;line-height:1;flex:none}" +
      ".prw-impact-data{display:flex;flex-direction:column;line-height:1.1}" +
      ".prw-impact-num{font-size:1.5rem;font-weight:700;color:var(--prw-accent)}" +
      ".prw-impact-label{font-size:.82rem;color:var(--prw-muted);margin-top:.1rem}" +
      ".prw-impact-foot{text-align:center;color:var(--prw-muted);font-size:.85rem;margin:.5rem 0 1.1rem}";
    document.head.appendChild(st);
  }
  function impactBlock(p) {
    if (p.orders == null || p.orders <= 0) return "";
    var o = p.orders;
    var items = [
      { icon: "🌲", n: o * IMPACT_PER_ORDER.trees, label: "trees planted" },
      { icon: "💧", n: o * IMPACT_PER_ORDER.bottles, label: "plastic bottles removed" },
      { icon: "🐝", n: o * IMPACT_PER_ORDER.bees, label: "bees protected" }
    ];
    var cards = items.map(function (it) {
      return '<div class="prw-impact-card"><span class="prw-impact-icon" aria-hidden="true">' + it.icon + "</span>" +
        '<span class="prw-impact-data"><span class="prw-impact-num">' + count(it.n) + "</span>" +
        '<span class="prw-impact-label">' + it.label + "</span></span></div>";
    }).join("");
    return '<div class="prw-impact"><p class="prw-impact-head">Every order also gives back through <strong>Greenspark</strong> — this drive so far:</p>' +
      '<div class="prw-impact-row">' + cards + "</div></div>" +
      '<p class="prw-impact-foot">Your group’s total climbs with every order.</p>';
  }
  function liveViewHtml(p) {
    var dl = daysLeft(p.end_date);
    ensureImpactStyles();
    var cards = (p.products || []).map(function (pr) {
      var img = pr.design_image || pr.featured_image || "";
      return '<a class="prw-fund-card" href="/products/' + esc(pr.handle) + '">' +
        '<span class="prw-fund-thumb">' + (img ? '<img loading="lazy" src="' + esc(img) + '" alt="' + esc(pr.design_alt || pr.title) + '">' : "") + "</span>" +
        '<span class="prw-fund-card-title">' + esc(pr.title) + "</span>" +
        (pr.price ? '<span class="prw-fund-card-price">' + money(pr.price) + "</span>" : "") + "</a>";
    }).join("");
    return '<section class="prw-fund-live"' + (p.accent_color ? ' style="--prw-accent:' + esc(p.accent_color) + '"' : "") + ">" +
      '<div class="prw-fund-hero">' +
      (p.hero_image ? '<div class="prw-fund-heroimg"><img src="' + esc(p.hero_image) + '" alt=""></div>' : "") +
      '<div class="prw-fund-herometa">' +
      (p.logo ? '<img class="prw-fund-logo" src="' + esc(p.logo) + '" alt="">' : "") +
      "<h2>" + esc(p.name) + "</h2>" +
      (p.headline ? '<p class="prw-fund-headline">' + esc(p.headline) + "</p>" : "") +
      (dl != null ? '<p class="prw-fund-ends">Ends in ' + dl + " day" + (dl === 1 ? "" : "s") + "</p>" : "") +
      progressBar(p) +
      '<button type="button" class="prw-fund-clear">Not your fundraiser? Clear selection</button>' +
      "</div></div>" +
      impactBlock(p) +
      (p.description ? '<div class="prw-fund-message"><p>' + esc(p.description) + "</p></div>" : "") +
      '<p class="prw-fund-note">These pieces were hand-picked by <strong>' + esc(p.org || p.name) + '</strong> for their fundraiser. Every order gives back to their cause.</p>' +
      '<div class="prw-fund-grid">' + cards + "</div></section>";
  }
  function activeListHtml(list) {
    if (!list || !list.length) return '<p class="prw-fund-empty">No active fundraisers right now. Check back soon.</p>';
    return '<div class="prw-fund-list-grid">' + list.map(function (f) {
      var dl = daysLeft(f.end_date);
      return '<a class="prw-fund-listcard" href="' + CUSTOMER_PAGE + "?ref=" + encodeURIComponent(f.ref) + '">' +
        '<span class="prw-fund-listname">' + esc(f.name) + "</span>" +
        (dl != null ? '<span class="prw-fund-listends">Ends in ' + dl + " day" + (dl === 1 ? "" : "s") + "</span>" : "") +
        '<span class="prw-fund-listcta">Shop this fundraiser &rarr;</span></a>';
    }).join("") + "</div>";
  }

  // ---------- /pages/active-fundraisers controller ----------
  function initCustomerPage(ref) {
    var root = document.getElementById("prw-fundraisers-root");
    if (!root) return;
    var live = root.querySelector("#prw-fund-live-mount");
    var listMount = root.querySelector("#prw-fund-list");
    var picker = root.querySelector("#prw-fund-picker");
    var sel = root.querySelector("#prw-ref-select");
    var form = root.querySelector("#prw-ref-form");
    var input = root.querySelector("#prw-ref-input");

    var listP = fetchList();

    if (sel) {
      listP.then(function (list) {
        var none = document.createElement("option");
        none.value = "__none__"; none.textContent = "None — shop without a fundraiser";
        sel.appendChild(none);
        list.forEach(function (f) {
          var o = document.createElement("option");
          o.value = f.ref; o.textContent = f.name;
          sel.appendChild(o);
        });
        if (ref) { try { sel.value = ref; } catch (e) {} }
      });
    }
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var v = (sel && sel.value) || "";
        if (!v && input) v = input.value;
        if (v === "__none__") { clearRef(); window.location.href = CUSTOMER_PAGE; return; }
        v = slug(v);
        if (v) window.location.href = CUSTOMER_PAGE + "?ref=" + encodeURIComponent(v);
      });
    }

    function showBrowse() { if (listMount) listP.then(function (list) { listMount.innerHTML = activeListHtml(list); }); }

    if (!ref) { showBrowse(); return; }
    fetchFundraiser(ref).then(function (p) {
      if (p && p.valid) {
        if (picker) picker.classList.add("prw-has-active");
        if (listMount) listMount.style.display = "none";
        if (live) {
          live.innerHTML = liveViewHtml(p);
          var btn = live.querySelector(".prw-fund-clear");
          if (btn) btn.addEventListener("click", function () { clearRef(); window.location.href = CUSTOMER_PAGE; });
        }
      } else {
        var msg = root.querySelector("#prw-ref-msg");
        if (msg) msg.textContent = p && p.reason === "not_active"
          ? "That fundraiser isn't active right now."
          : "We couldn't find that code. Pick one from the list below.";
        showBrowse();
      }
    });
  }

  // ---------- boot ----------
  var ref = activeRef();
  preDim(ref);
  document.addEventListener("DOMContentLoaded", function () {
    initCustomerPage(ref);
    if (!ref) { reveal(); return; }
    fetchFundraiser(ref).then(function (p) {
      if (p && p.valid) {
        swapPdpImage(p);
        var banner = document.getElementById("prw-fundraiser-banner");
        if (banner) {
          var sub = "Your purchase gives back to this fundraiser." +
            (p.raised != null && p.goal ? " " + money(p.raised) + " raised of " + money(p.goal) + "." : "");
          banner.innerHTML =
            '<div class="prw-pdp-fund">' +
            (p.logo ? '<img class="prw-pdp-fund-logo" src="' + esc(p.logo) + '" alt="">' : '<span class="prw-pdp-fund-heart" aria-hidden="true">&#10084;</span>') +
            '<div class="prw-pdp-fund-body">' +
            '<div class="prw-pdp-fund-name">Supporting <strong>' + esc(p.name) + "</strong></div>" +
            '<div class="prw-pdp-fund-sub">' + esc(sub) + "</div></div>" +
            '<a class="prw-pdp-fund-link" href="' + CUSTOMER_PAGE + "?ref=" + encodeURIComponent(ref) + '">View &rarr;</a></div>';
        }
      } else { reveal(); }
    });
  });

  window.PRWFundraiser = { activeRef: activeRef, clear: clearRef, fetch: fetchFundraiser, list: fetchList };
})();